import { NextRequest } from 'next/server';

export const getLocaleFromHost = (req: NextRequest): 'ru' | 'az' => {
  const forwardedHostRaw = req.headers.get('x-forwarded-host');
  const hostRaw = req.headers.get('host') || '';

  const raw = forwardedHostRaw || hostRaw;

  const host = String(raw).split(',')[0].trim().toLowerCase();

  // Remove port if present (e.g., "ru.bina.az:3000" -> "ru.bina.az")
  const hostname = host.split(':')[0];

  // Check if hostname starts with "ru." (case-insensitive after toLowerCase)
  return hostname.startsWith('ru.') ? 'ru' : 'az';
};

export const cleanHtmlExtension = (pathname: string): string =>
  pathname.endsWith('.html') ? pathname.replace(/\.html$/, '') : pathname;
